export const sleep = async <T>(result: any, time?: number): Promise<typeof result> => {
  const t = time || 0;
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(result);
    }, t);
  });
};
